<template>
  <div>
    <v-icon
      v-show="!!icon"
      small
      class="mr-2"
    >
      {{ icon }}
    </v-icon>
    <a
      :href="readableUrl"
      target="_blank"
    >{{ label }}</a>
  </div>
</template>

<script>
export default {
  name: "LinkWithIcon",
  props: {
    isMailto: {
      type: Boolean,
      default: false
    },
    icon: {
      type: String,
      default: null
    },
    url: {
      type: String,
      required: true
    },
    label: {
      type: String,
      required: true
    }
  },
  computed: {
    readableUrl() {
      if (!this.url) {
        return
      }
      if (this.isMailto) {
        return "mailto:" + this.url
      }
      if (!/^https?:\/\//.test(this.url)) {
        return "http://" + this.url
      }
      return this.url
    }
  }
}
</script>

<style>
</style>